<template>
<!-- Star Clients Area
    ============================================= -->

    <!-- Star Faq
    ============================================= -->
    <div class="faq-area default-padding bg-gray">
      <div class="container">
        <div class="faq-items">
          <div class="row">
            <div class="col-lg-6">
              <div class="faq-content">
                <h2>Preguntas frecuentes</h2>
                <div class="accordion" id="accordionExample">
                  <div class="card">
                    <div class="card-header" id="headingOne">
                      <h4
                        class="mb-0"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        ¿Cuánto tiempo toma implementar Vapp?
                      </h4>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <p>
                          Nuestra plataforma es una potente herramienta que nos
                          permite implementar en 2 horas* un entono
                          completamente disponible para un cliente y si no
                          estuviese dentro de nuestras implementaciones nos
                          comprometemos a realizar en el menor tiempo posible
                          los nuevos requerimientos.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header" id="headingTwo">
                      <h4
                        class="mb-0 collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        ¿Cuáles son las ventajas?
                      </h4>
                    </div>
                    <div
                      id="collapseTwo"
                      class="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <p>
                          Tener un escritorio en Vapp nos permite centralizar
                          las herramientas que son de Desktop como Web en un
                          solo lugar, nos encargamos de dar el soporte de
                          primera línea a tus aplicaciones para que no tengas
                          que encargarte de la implementación he
                          infraestructura, es hora de elegir las aplicaciones y
                          comenzar a utilizar tu escritorio en la nube.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header" id="headingThree">
                      <h4
                        class="mb-0 collapsed"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        ¿Qué programas puedo tener en Vapp?
                      </h4>
                    </div>
                    <div
                      id="collapseThree"
                      class="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <p>
                          Puedes tener los programas que tu quieras!, para que
                          tus colaboradores trabajen en comodidad, solo háznoslo
                          saber y lo dejamos listo.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="thumb wow fadeInLeft" data-wow-delay="0.5s">
                <img src="assets/img/illustration/7.png" alt="Thumb" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Faq -->
</template>


<script>
    export default {
        name: "Banner4",
        components: {},
        beforeMount() {},
    };
</script>